<template>
  <SectionHeadlineImage
    class="SectionWhyWorth"
    :head="$t('head')"
    :headline="$t('headline')"
    imageSrc="../../../../assets/landing-static/map.png"
    :side="$t('side')" />
</template>

<script>
import SectionHeadlineImage from 'views/components/SectionHeadlineImage'

export default {
  components: { SectionHeadlineImage },
}
</script>

<style lang="scss">
.SectionWhyWorth {}
</style>

<i18n>
{
  "lt": {
    "headline": "Kodėl verta?",
    "head": "Lietuvoje jau daugiau nei 700 vartotojų džiaugiasi mūsų pastatyta saulės elektrine.\n\n**Prisijunkite ir Jūs!**",
    "side": "- atsiperka per 5-7 metus\n- 80% mažesnės sąskaitos už elektrą\n- galimybė gauti paramą;\n- elektrinę įsigyti galite išsimokėtinai"
  }
}
</i18n>
